import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { PagerService } from '../../services/pager.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PartGroupService } from '../../services/partgroup.service';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit, OnChanges {
    pager: any;
    pagedItems: any[];
    pageSize: number;
    initialSize = 8;
    pageSizes: number[] = new Array();
    pagerData: Pager;
    maxPerPage = 32;
    filterValue: string
    selectedChar: string
    pageNumberurl: number
    isPageReload: boolean
    isBackButton: boolean

    private destroy$ = new Subject<void>();

    @Input() itemsCount: number;
    @Output() setPageData = new EventEmitter<Pager>();
    constructor(private _pagerService: PagerService, private _router: Router,
              private route: ActivatedRoute, private _partGroupService: PartGroupService) { }

    ngOnInit(): void {
      this.loadPageData();
    }

    ngOnChanges() {
        this.loadPageData();
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }

    loadPageData(pageNumberValue: number = 1)
    {
      Observable.combineLatest(
        this._partGroupService.sharedValue$,
        this._partGroupService.sharedPageValue$,
        this._partGroupService.sharedBackButtonValue$,
        (val1, val2, val3) => ({ val1, val2, val3})
        ).subscribe(result => {
            this.filterValue = result.val1;
            this.isPageReload = result.val2;
            this.isBackButton = result.val3;
      });

      this.pager = {};
      this.pageSizes = [];
      this.pageSize = 8;

      // To get the paginated page
      if (this._router.url.includes('/manage/partgroup?filter')) {
        const { routeValue, filterValue, pageNumber } = this._pagerService.getState();
        this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
          this.selectedChar = params['filter'] || '';
          this.pageNumberurl = params['page'] ? +params['page'] : 1;
        });

        this._pagerService.getPageSize() ? this.pageSize = this._pagerService.getPageSize() : this.pageSize = 8;
        pageNumberValue = (this.filterValue == filterValue && this.filterValue == this.selectedChar) ? this.pageNumberurl : pageNumberValue;
        this.filterValue == "All" && this.isPageReload ? pageNumberValue = 1 : this.pageNumberurl;
        this.itemsCount < 8 ? this.pageSize = 8 : this.pageSize;
      }
      this.setPage(pageNumberValue);
      this.setPageSizeValues();
    }

    setPage(page: number) {
        if (this._router.url.includes('/manage/partgroup?filter')) {
            this._router.navigate([], {
              relativeTo: this.route,
              queryParams: { page },
              queryParamsHandling: 'merge',
            });
            if (this.selectedChar) {
              this._pagerService.setState(this._router.url, this.filterValue, page);
              if (this.pager.pageSize != undefined) {
                this._pagerService.setPageSize(this.pageSize);
              }
              this.pager.currentPage = page;
            }
        }
        if (page < 1 || page > this.pager.totalPages) {
                return;
        }
        this.pager = this._pagerService.getPager(this.itemsCount, page, parseInt(this.pageSize.toString()));
        var pageIndex = this.pager.pages.indexOf(page);
      if (pageIndex == -1) {
          page = 1;
          this.pager = this._pagerService.getPager(this.itemsCount, page, parseInt(this.pageSize.toString()));
          this._router.navigate([], {
            relativeTo: this.route,
            queryParams: { page },
            queryParamsHandling: 'merge',
          });
        }
      this.pagerData = new Pager(this.pager.startIndex, this.pager.endIndex + 1);
      this.setPageData.emit(this.pagerData);
    }

    setPageSizeValues() {
        this.pageSizes.push(this.initialSize);
        while (this.initialSize < this.itemsCount && this.initialSize < this.maxPerPage) {
            this.initialSize = this.initialSize * 2;
            this.pageSizes.push(this.initialSize);
        }
       this.initialSize = 8;
  }
}

export class Pager {
    constructor(public startIndex: number, public endIndex: number) {
    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/components/pagination/pagination.component.ts